import { GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS } from "../../../../../queries/v3/pages/BookAppointment/queries/get-book-appointment-try-in-store-products.js";
const getBookAppointmentTryInStoreProducts = async (apolloClient, skus, locale) => {
  try {
    const { data, error } = await apolloClient.query({
      query: GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS,
      variables: {
        skus
      },
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    });
    const productsQueryData = data.getProductsBySKUs;
    const productsData = productsQueryData.flatMap((product) => {
      return product.variants.map((variant) => {
        const image = variant.media.images[0];
        return {
          __itemType: "product",
          name: product.name,
          slug: product.slug,
          price: {
            amount: variant.prices.discountedPrice?.price?.amount || variant.prices.originalPrice?.amount,
            currencyCode: variant.prices.discountedPrice?.price?.currencyCode || variant.prices.originalPrice?.currencyCode
          },
          image: {
            url: image.url
          }
        };
      });
    });
    if (error) {
      console.error(error);
    }
    return productsData;
  } catch (error) {
    console.error(error);
    return void 0;
  }
};
export {
  getBookAppointmentTryInStoreProducts
};
//# sourceMappingURL=book-appointment-try-in-store-products.js.map
